import React from 'react';
import { Form, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ReportNameSelect } from './ReportNameSelect';
import { DistrictSelect } from './DistrictSelect';
import { LocalitySelect } from './LocalitySelect';
import { OrganizationTypesSelect } from './OrganizationTypesSelect';
import { OrganizationSelect } from './OrganizationSelect';
import { YearSelect } from './YearSelect';
import { setFormSelectors, resetState } from '../../../../../redux/actions/reportStatus';
import { loadReportStatus } from '../../../../../redux/asyncActions/reportStatus';
import './styles.scss';

export const FormControls = ({ form }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleFinish = (values) => {
    dispatch(setFormSelectors(values));
    dispatch(loadReportStatus(values));
  };

  const handleClear = () => {
    form.resetFields();
    dispatch(resetState());
  };

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout='vertical'
      className='container-selectors'
    >
      <ReportNameSelect />
      <DistrictSelect />
      <LocalitySelect />
      <OrganizationTypesSelect />
      <OrganizationSelect />
      <YearSelect />

      <Form.Item>
        <div className='container-buttons'>
          <Button type='primary' htmlType='submit'>
            {t('governmentServiceEducation.search')}
          </Button>
          <Button type='default' onClick={handleClear}>
            {t('governmentServiceEducation.clear')}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
